__webpack_require__.p = "/magazin/horoscopo/";